import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { User, UserRole } from "@/types";

interface AuthState {
  user: User | null;
  role: UserRole;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  setRole: (role: UserRole) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      role: "ADMIN",
      isAuthenticated: false,
      setUser: (user) =>
        set({
          user,
          role: user?.role || "ADMIN",
          isAuthenticated: !!user,
        }),
      setRole: (role) => set({ role }),
      logout: () =>
        set({
          user: null,
          role: "ADMIN",
          isAuthenticated: false,
        }),
    }),
    {
      name: "wonlet-auth",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
